import React from 'react';
import { Box, Typography } from '@mui/material';
import TransactionsGrid from '../../components/TransactionsGrid';
import { ROLES } from '../../config/roles';

const TransactionsPage = () => (
    <Box sx={{ p: 2 }}>
        <Typography variant="h4" gutterBottom>Transactions</Typography>
        <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
            Today (UTC) — change the date filter for wider ranges. Default is balance + activity for all players.
        </Typography>
        <TransactionsGrid />
    </Box>
);

TransactionsPage.abilities = {
    read: [ROLES.SUPPORT, ROLES.ADMINS, ROLES.VIEWERS],
};

export default TransactionsPage;